import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    contactLogin: [],
    error: "",
}



const contactusSlice = createSlice({
    name: 'contactus',
    initialState,
    reducers: {
        contactLoginuser: (state, action) => {
            state.contactLogin = action.payload
        },

    }
})

export const { newUser, contactLoginuser } = contactusSlice.actions;
export default contactusSlice.reducer;


export const getcontactLogin = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.GET_USER_CONTACT_DETAILS}`, data);
            callback(response)
            dispatch(contactLoginuser(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }




